import React from 'react';

import { AppStoreButtons } from '../../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { CTAButton } from '../../../../components/Clickables/Buttons/CTAButton/CTAButton';
import { Heading } from '../../../../components/Heading/Heading';
import { QRCode } from '../../../../components/QRCode/QRCode';
import { Text } from '../../../../components/Text/Text';
import { IModalContent } from '../../constants/proModalContent';
import NextImage from 'next/image';

export const ProMapLayerModal = ({ headline, description, image, CTA }: IModalContent) => {
  return (
    <div data-testid="ProModal" className="flex h-full flex-col justify-end sm:flex-row">
      <div className="flex flex-col items-start justify-around gap-4 px-6 pb-4 pt-8 sm:w-3/5 sm:px-11">
        <Heading as="h1" variant="lg" className="my-0">
          {headline}
        </Heading>
        <Text variant="lg" className="mb-0">
          {description}
        </Text>
        {CTA ? (
          <CTAButton type="pro" variant="buttonPro" source="mapLayers" className="mb-10 mt-8 w-max">
            {CTA}
          </CTAButton>
        ) : (
          <div className="flex w-full justify-center gap-4">
            <AppStoreButtons
              orientation="vertical"
              className="justify-center"
              source="ProMapLayerModal"
            />
            <QRCode className="hidden w-full sm:flex" source="ProMapLayerModal" />
          </div>
        )}
      </div>
      <div className="relative size-full sm:w-2/5">
        <NextImage
          className="size-full object-cover drop-shadow-phoneMobile sm:drop-shadow-phoneDesktop"
          src={image}
          placeholder="blur"
          alt="App Section"
          fill
          sizes="(min-width: 1280px) 512px, (min-width: 600px) 40vw, 100vw "
        />
      </div>
    </div>
  );
};
